module.exports = __webpack_public_path__ + "img/logo.a0cc31c1.png";